import React from 'react'

export default function Activating() {
  return (
    <div className="container activating">
      <div className="dialog">
        <h2>Your account is waiting on MLS approval.</h2>
        <p>Apologies for the delay! Please check your email for the latest on the MLS approval process.</p>
        <p>If you believe there is some other problem or need help, feel free to <a href="mailto:help@showcaseidx.com">contact support</a>.</p>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// client/components/Activating.js